

export default {
  name: 'IcoConverter',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "Do we have to download ICO converters?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "No. We can choose web-based converters if we don't want to download and install any app. These tools allow us to use them when we are online. Then, we can visit the site whenever we want to convert files."
          }
      },{
          "@type": "Question",
          "name": "Is the ICO converter free?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes. Online converts don't charge you any cost and will never do. Hence, feel free to use them to work with your ICO files."
          }
      },{
          "@type": "Question",
          "name": "How do I reduce the size of my ICO?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can easily convert ICO to JPEG if the converter supports it. If yes, you can take these steps to process the file: Select the .ICO file on your computer. Set the picture's dimensions. Process and save the JPEG file."
          }
      },{
          "@type": "Question",
          "name": "How do I create an ICO file with multiple sizes?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "You need GIMP for this purpose. And here is how to use it: Open the image in GIMP. Square up your canvas. Resize the image's layer. Set the layer's size to the highest value in your ICO, such as 64 pixels. Create a duplicate of the layer. Increase the duplicate layer's dimension. Continue scaling and duplicating until your file has all the sizes you need. Save data as .ICO."
          }
      }]
    };
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        progress: 0,
        loading: false,
        isActive: false,
        size: 32,
        form: this.$vform({ })
    };
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onIcoConverter() {

        this.progress = 0;

        const config = {
          onUploadProgress: (progressEvent) => this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        };

        const data = new FormData();

        data.append('local_image', this.local_image);
        data.append('size', this.size);

        this.loading = true;

        this.$axios.post(`/tool/ico-converter`, data, config, { headers: { 'Content-Type': 'multipart/form-data', 'Accept': 'multipart/form-data' } }).then(res => {
           
            jQuery('.download-image').attr( 'href',  res.data.download );

            jQuery('.preview-download-image').attr('src', res.data.preview);

            jQuery('#modalPreviewDownloadImage').modal('show');

        }).catch(e => {

          this.form.errors.set(e.response.data.errors);

        }).finally(() => {

          this.loading = false

       });
    }
  }
}
